import React from 'react';
import ErrorMessage from "../../components/ErrorMessage";
import SuccessMessage from "../../components/SuccessMessage";
import HomeScreen from "../homescreen/homescreen";
import LoadingComponent from "../../components/Loading";
import Service from "../../service/service";
import './style.css';

class Contact extends HomeScreen {

    contactInfo = {
        name: "",
        email: "",
        subject: "",
        message: ""
    }

    state = {
        contactInfo: this.contactInfo,
        loading: false,
        errorMessage: null,
        success: false
    }

    service = new Service();

    renderHomeContent() {
        const {loading, errorMessage, success} = this.state;
        const buttonClass = loading ? 'myButton myButtonDisabled' : 'myButton myButtonActive';

        if (success) {
            return (
                <SuccessMessage message='Message sent successfully.'/>
            );
        }
        return (
            <div>
                <p className='sectionDescription'>If you have any question, feedback or just want to say hi, complete the following form.</p>
                <div className='formContainer'>
                    <div>
                        <label>Name:</label>
                        <input type='text'
                               name='name'
                               placeholder='Name'
                               value={this.contactInfo.name}
                               onChange={this.handleChange} disabled={loading} />
                    </div>


                    <div>
                        <label>Email:</label>
                        <input type='text'
                               name='email'
                               placeholder='Email'
                               value={this.contactInfo.email}
                               onChange={this.handleChange} disabled={loading} />
                    </div>

                    <div>
                        <label>Subject:</label>
                        <input type='text'
                               name='subject'
                               placeholder='Subject'
                               value={this.contactInfo.subject}
                               onChange={this.handleChange} disabled={loading} />
                    </div>

                    <div>
                        <label>Message:</label>
                        <textarea name='message'
                                  value={this.contactInfo.message}
                                  placeholder='Message'
                                  onChange={this.handleChange} disabled={loading} />
                    </div>

                    <LoadingComponent isLoading={loading} />

                    <ErrorMessage errorMessage={errorMessage} type='warning'/>



                </div>

                <div className='buttonContainer'>
                    <div className={buttonClass} onClick={this.sendContactMessage}>Submit</div>
                </div>
            </div>
        );
    }

    handleChange = (event) => {
        this.contactInfo[event.target.name] = event.target.value;
        this.setState(this.contactInfo);
    };

    sendContactMessage = () => {
        if (this.state.loading == true) {
            return;
        }
        if (!this.validateContactInfo()) {
            this.state.errorMessage = "Please, complete all the fields.";
            this.setState(this.state);
            return;
        }

        console.log('submitting msg');
        this.state.errorMessage = null;
        this.state.loading = true;
        this.setState(this.state);

        this.service.sendContactMessage(this.contactInfo)
            .then(response => {
                console.debug(response);
                this.state.loading = false;
                this.state.success = true;
                this.setState(this.state);
            })
            .catch(error => {
                this.state.errorMessage = 'There was an error sending the message';
                this.state.loading = false;
                this.setState(this.state);
                console.log(error);
            });

    }

    validateContactInfo = () => {

        const {contactInfo} = this.state;
        if (!contactInfo) {
            return false;
        }

        if (!contactInfo.name || !contactInfo.email || !contactInfo.message || !contactInfo.subject) {
            return false;
        }

        return true;
    };

    getScreenName() {
        return 'Contact';
    }
}

export default Contact;


// WEBPACK FOOTER //
// ./src/screens/contact/index.js